import { IPromoInfoSchema } from '../../../../../types/promo';

export function getImageUrl(promo: IPromoInfoSchema): string {
  if (promo.isFromBank) {
    return promo.bank?.secondSquareImageUrl || '';
  }

  return promo.authorLogoUrl || '';
}
